import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const TitleWrapper = styled.div`
  text-align: center;
  > h1 {
    font-family: ${(props) => props.theme.fontFamily};
    color: ${(props) => props.theme.fontColor};
  }
`;

const Title = () => (
  <TitleWrapper>
    <h1>
      <FormattedMessage defaultMessage="Login" />
    </h1>
  </TitleWrapper>
);

export default Title;
